export default __webpack_public_path__ + "static/media/6.01b8fb2c.png";